/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { JobsControllerFindAllQueryResponse, JobsControllerFindAllQueryParams, JobsControllerFindAll401, JobsControllerFindAll403 } from "../../models/jobsController/JobsControllerFindAll";

function getJobsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/jobs` as const }  
  return res
}

/**
 * @summary Get all jobs
 * {@link /api/v1/jobs}
 */
export async function jobsControllerFindAll(params?: JobsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<JobsControllerFindAllQueryResponse, ResponseErrorConfig<JobsControllerFindAll401 | JobsControllerFindAll403>, unknown>({ method : "GET", url : getJobsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}